import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "delete-modal" */'./DeleteModal'),
  LoadingComponent: () => null
});